<script>

const axios = require('axios').default;

export default {
  name: 'ProvidersIndex',
  mixins: [axios],
  props: {
    counties: {
      required: false,
      type: Array,
      default: function () {
        return null;
      }
    },
    categories: {
      required: false,
      type: Array,
      default: function () {
        return null;
      }
    },
    filterDefaults: {
      county_fips: null,
      category_id: null,
      subcategory_id: null,
      name: '',
      is_aging_resource: null,
    },
  },
  computed: {
    pageNumbers() {
      const range = (start, stop) => Array.from({length: (stop - start) + 1}, (_, i) => start + i);
      let pageCount = this.paginator.last_page
      let currentPage = this.paginator.current_page
      if (this.paginator.current_page < 10) {
        return Array(Math.min(pageCount, 10)).keys()
      } else {
        return range(currentPage - 6, Math.min(currentPage + 4, pageCount));
      }
    }
  },
  data() {
    return {
      providersData: {},
      show: {
        category: null,
        subcategory: null,
      },
      subcategories: null,
      filter: {
        county_fips: null,
        category_id: null,
        subcategory_id: null,
        name: '',
        is_aging_resource: null,
      },
      displayResults: false,
      lastQuery: null,
      paginator: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 10,
        prev_page_url: null,
        total: 0,
      }
    };
  },
  created() {
    this.initializeFilters();
  },
  methods: {
    initializeFilters(clear = false) {
      if (clear) {
        this.filter = {
          county_fips: null,
          category_id: null,
          subcategory_id: null,
          name: '',
          is_aging_resource: null,
        }
        this.getProviders()
      } else {
        let fetch = false
        this.filter.county_fips = this.filterDefaults.county_fips
        this.filter.category_id = this.filterDefaults.category_id
        if (this.filter.category_id) {
          fetch = true
          let categoryIndex = Object.keys(this.categories).filter(function (row) {
            return this.categories[row].id === this.filter.category_id;
          }, this);
          this.setSubcategoriesList(this.categories[categoryIndex].subcategories)
        }
        this.filter.subcategory_id = this.filterDefaults.subcategory_id
        if (this.filterDefaults.subcategory_id !== null) {
          fetch = true
        }
        this.filter.name = this.filterDefaults.name
        if (this.filterDefaults.name !== '') {
          fetch = true
        }
        this.filter.is_aging_resource = this.filterDefaults.is_aging_resource
        if (this.filterDefaults.is_aging_resource !== null) {
          fetch = true
        }
        if (fetch) {
          this.getProviders();
        }
      }


    },
    getProviders(pageNumber = 1) {
      this.displayResults = false
      let params = this.filter
      params.page = pageNumber
      params.per_page = this.paginator.per_page

      this.lastQuery =
          axios.get('/providers/search?' + this.urlParams(params)).then((response) => {
            this.paginator.last_page = response.data.providers.last_page
            this.paginator.total = response.data.providers.total
            this.paginator.current_page = response.data.providers.current_page
            this.providersData = response.data.providers.data
            this.displayResults = true
          }).catch((response) => {
            this.lastQuery = ''
            this.paginator.last_page = 1
            this.paginator.current_page = 1
            this.paginator.total = 0
          })
    },
    providerCategories(subcategories) {
      return subcategories[0].category
    },
    changePage(page) {
      this.displayResults = false
      if (this.paginator.current_page !== page) {
        this.paginator.current_page = page
        this.getProviders(this.paginator.current_page)
      }
    },
    setSubcategoriesList(list) {
      this.subcategories = list
      this.filter.subcategory_id = null
    },
    urlParams(myData) {
      let out = [];
      for (let key in myData) {
        if (myData.hasOwnProperty(key) && myData[key] != null) {
          out.push(key + '=' + encodeURIComponent(myData[key]));
        }
      }
      return out.join('&');
    },
  }
}

</script>

<template>
  <!-- FILTER  -->
  <div class="border-b-4 border-gold-default text-lg py-6">
    <form @submit.prevent="getProviders()" method="get">
      <div class="flex flex-col lg:flex-row gap-6">
        <div class="bg-white rounded-full shadow-md h-12 text-black mb-2 w-full lg:w-1/4">
          <select v-model="filter.county_fips" class="h-12 rounded-full my-auto py-2 px-4 w-full">
            <option :value="null">County</option>
            <option v-for="county in counties" :value="county.fips">{{
                county.name
              }}
            </option>
          </select>
        </div>
        <div class="bg-white rounded-full shadow-md h-12 text-black mb-2 w-full lg:w-1/4">
          <select v-model="filter.is_aging_resource" class="h-12 rounded-full my-auto py-2 px-4 w-full">
            <option :value="null">Aging/Disability</option>
            <option :value="1">Aging</option>
            <option :value="0">Disability</option>
          </select>
        </div>
        <div class="bg-white rounded-full shadow-md h-12 text-black mb-2 w-full lg:w-1/4">
          <select v-model="filter.category_id" class="h-12 rounded-full my-auto py-2 px-4 w-full">
            <option :value="null">Categories</option>
            <template v-for="category in categories">
              <option :value="category.id" @click="setSubcategoriesList(category.subcategories)">{{
                  category.name
                }}
              </option>
            </template>
          </select>
        </div>
        <div class="bg-white rounded-full shadow-md h-12 text-black mb-2 w-full lg:w-1/4">
          <select v-model="filter.subcategory_id" class="h-12 rounded-full my-auto py-2 px-4 w-full">
            <option :value="null">Subcategories</option>
            <template v-for="subcategory in subcategories">
              <option :value="subcategory.id">{{ subcategory.name }}</option>
            </template>
          </select>
        </div>
        <div class="mb-2 w-full lg:w-1/4">
          <span class="rounded-full flex bg-white flex-row  shadow-md">
            <input type="text" v-model="filter.name"
                   class="h-12 my-auto py-2 px-4 w-full border-gray-200 rounded-l-full"
                   placeholder="Name">
            <button type="submit"
                    class="bg-gold-default hover:bg-gold-darker text-white font-semibold py-2 px-4 rounded-full">
              <i class="fas fa-search"></i>
            </button>
          </span>
        </div>
        <button type="button"
                @click="initializeFilters(true)"
                class="bg-navy-default text-white font-semibold h-12 py-2 px-5 rounded-full">
          <i class="far fa-times"></i>
        </button>
      </div>
    </form>
  </div>

  <!-- DISPLAY RESULTS  -->
  <div v-if="displayResults">
    <div class="grid grid-cols-1 xl:grid-cols-3 grid-flow-row auto-rows-min my-6 gap-4 min-h-screen">
      <div v-for="provider in providersData" v-if="providersData.length">
        <a :href="'/providers/' + provider.id"
           class="bg-white flex flex-col cursor-pointer rounded-md shadow border-b-default  border-gray-200 p-5 my-1">
          <div class="text-3xl text-cerulean-default mb-4">
            {{ provider.name }}
          </div>
          <div>
            <p class="text-sm truncate">{{ provider.description }}</p>
          </div>
          <div class="text-sm mt-4 flex flex-wrap">
            <div class="font-semibold mr-2">Services:</div>
            <div v-for="taxonomy in provider.taxonomies" class="mr-2">{{ taxonomy.name }},</div>
          </div>
        </a>
      </div>
      <div v-else>
        No results, update you search parameters and try again.
      </div>
    </div>
    <div class="text-center py-6 border-t-4 border-gold-default " v-if="paginator.last_page!==1">
      <p class="mb-6">
        Showing {{ (paginator.current_page - 1) * paginator.per_page + 1 }} -
        {{ Math.min((paginator.current_page) * paginator.per_page, paginator.total) }} of {{ paginator.total }}
      </p>
      <nav class="flex flex-row justify-center">
        <button @click="changePage(this.paginator.current_page-1)"
                :disabled="paginator.current_page === 1"
                class="px-5 py-2 text-indigo-600 transition-colors duration-150 border rounded-l-lg focus:shadow-outline hover:bg-indigo-100">
          <i class="fas fa-chevron-left"></i>
        </button>
        <select class=" py-2 px-4 border-t border-b" @change="changePage($event.target.value)">
          <template v-for="pageNumber in pageNumbers">
            <option :value="pageNumber+1"
                    :selected="paginator.current_page === pageNumber+1">
              {{ pageNumber + 1 }}
            </option>
          </template>
        </select>
        <button @click="changePage(paginator.current_page+1)"
                :disabled="paginator.current_page === paginator.last_page"
                class="px-5 py-2 text-indigo-600 transition-colors duration-150 border bg-white rounded-r-lg focus:shadow-outline hover:bg-indigo-100">
          <i class="fas fa-chevron-right"></i>
        </button>
      </nav>
    </div>
  </div>
</template>